var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisualizzaClassifica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3547_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.57143 4.21875C8.57143 2.82129 9.72321 1.6875 11.1429 1.6875H12.8571C14.2768 1.6875 15.4286 2.82129 15.4286 4.21875V22.7812C15.4286 24.1787 14.2768 25.3125 12.8571 25.3125H11.1429C9.72321 25.3125 8.57143 24.1787 8.57143 22.7812V4.21875ZM0 14.3438C0 12.9463 1.15179 11.8125 2.57143 11.8125H4.28571C5.70536 11.8125 6.85714 12.9463 6.85714 14.3438V22.7812C6.85714 24.1787 5.70536 25.3125 4.28571 25.3125H2.57143C1.15179 25.3125 0 24.1787 0 22.7812V14.3438ZM19.7143 5.0625H21.4286C22.8482 5.0625 24 6.19629 24 7.59375V22.7812C24 24.1787 22.8482 25.3125 21.4286 25.3125H19.7143C18.2946 25.3125 17.1429 24.1787 17.1429 22.7812V7.59375C17.1429 6.19629 18.2946 5.0625 19.7143 5.0625Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3547_51"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 27,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualizzaClassifica);
export default __webpack_public_path__ + "static/media/visualizza-classifica.83b44a94944b9c4f40a1a0c1d1aaae64.svg";
export { ForwardRef as ReactComponent };